import { CategoryTileProps } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTile';
import WeddingGift from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/do-i-have-to-buy-a-wedding-shower-gift-and-a-wedding-gift.jpg';
import DosDonts from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/dos-and-donts-for-wedding-guests.jpg';
import GiftGiving from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/everything-wedding-guests-need-to-know-about-gift-giving-right-now.jpg';
import GroupGifting from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/everything-you-need-to-know-about-group-gifting.jpg';
import HatePublicSpeaking from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/give-wedding-speech-hate-public-speaking.jpg';
import HowMuchToSpend from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/how-much-to-spend-on-a-wedding-gift.jpg';
import HowToRSVP from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/how-to-rsvp-to-a-wedding.jpg';
import AskForAPlusOne from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/is-it-ever-ok-to-ask-for-a-1-to-a-wedding.jpg';
import SaveMoney from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/save-money-as-a-wedding-guest.jpg';
import BlackTie from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/what-to-wear-and-not-wear-to-a-black-tie-wedding.jpg';
import WeddingCard from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/what-to-write-in-a-wedding-card.jpg';
import GuestBookEntry from '../../../../../public/static-preauth/images/Search/CoupleSearch/EASection/write-a-wedding-guest-book-entry.jpg';

const dosDontTile: CategoryTileProps = {
  altText: '',
  image: DosDonts,
  linkText: "Do's and Don'ts for Wedding Guests",
  href: '/expert-advice/dos-and-donts-for-wedding-guests',
};

const giftGivingTile: CategoryTileProps = {
  altText: '',
  image: GiftGiving,
  linkText: 'Everything Guests Need to Know about Gift Giving',
  href: '/expert-advice/everything-wedding-guests-need-to-know-about-gift-giving-right-now',
};

const saveMoneyTile: CategoryTileProps = {
  altText: '',
  image: SaveMoney,
  linkText: 'How to Save Money as a Wedding Guest',
  href: '/expert-advice/save-money-as-a-wedding-guest',
};

const howToRSVPTile: CategoryTileProps = {
  altText: '',
  image: HowToRSVP,
  linkText: 'How to RSVP to a Wedding',
  href: '/expert-advice/how-to-rsvp-to-a-wedding',
};

const hatePublicSpeakingTile: CategoryTileProps = {
  altText: '',
  image: HatePublicSpeaking,
  linkText: 'How to Give a Wedding Speech If You Hate Public Speaking',
  href: '/expert-advice/give-wedding-speech-hate-public-speaking',
};

const howMuchToSpendTile: CategoryTileProps = {
  altText: '',
  image: HowMuchToSpend,
  linkText: 'How Much to Spend on a Wedding Gift',
  href: '/expert-advice/how-much-to-spend-on-a-wedding-gift',
};

const groupGiftingTile: CategoryTileProps = {
  altText: '',
  image: GroupGifting,
  linkText: 'Everything You Need to Know About Group Gifting',
  href: '/expert-advice/everything-you-need-to-know-about-group-gifting',
};

const guestBookEntryTile: CategoryTileProps = {
  altText: '',
  image: GuestBookEntry,
  linkText: "How to Write a Memorable Guest Book Entry'",
  href: '/expert-advice/write-a-wedding-guest-book-entry',
};

const blackTieTile: CategoryTileProps = {
  altText: '',
  image: BlackTie,
  linkText: 'What to Wear (and Not Wear) to a Black Tie Wedding',
  href: '/expert-advice/dos-and-donts-for-wedding-guests',
};

const askForAPlusOneTile: CategoryTileProps = {
  altText: '',
  image: AskForAPlusOne,
  linkText: 'Is It Ever OK to Ask for a +1 to a Wedding?',
  href: '/expert-advice/is-it-ever-ok-to-ask-for-a-1-to-a-wedding',
};

const weddingCardTile: CategoryTileProps = {
  altText: '',
  image: WeddingCard,
  linkText: 'What to Write in a Wedding Card',
  href: '/expert-advice/what-to-write-in-a-wedding-card',
};

const weddingShowerGiftTile: CategoryTileProps = {
  altText: '',
  image: WeddingGift,
  linkText: 'Do I have to Buy a Wedding Shower Gift and a Wedding Gift?',
  href: '/expert-advice/do-i-have-to-buy-a-wedding-shower-gift-and-a-wedding-gift',
};

export const articleTiles = [
  dosDontTile,
  giftGivingTile,
  saveMoneyTile,
  howToRSVPTile,
  hatePublicSpeakingTile,
  howMuchToSpendTile,
  groupGiftingTile,
  guestBookEntryTile,
  blackTieTile,
  askForAPlusOneTile,
  weddingCardTile,
  weddingShowerGiftTile,
];
